import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">

          <h2 id="session1">
            Special Session 1: &quot;Swarm Intelligence and Machine Learning in
            Management Science and Industrial Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <p>
            With the rapid development of computation power and artificial
            intelligence, swarm intelligence and machine learning have attracted
            attention from both researchers and engineers in the field of
            management science, computer engineering, scheduling,
            bioinformatics, data mining, design optimization, etc. Swarm
            intelligence algorithms, inspired by the behavior in self-organized
            groups, such as birds, ants, bacteria, etc., hold the superiority in
            complex optimization problems. Machine learning algorithms, such as
            the reinforcement learning algorithms, have shown strong ability in
            interactive learning environment. How to utilize swarm intelligence
            algorithms and machine learning algorithms to deal with problems in
            management and industrial fields remains to be an interesting topic.{" "}
            <br />
            <br />
            The objective of this special session is to gather recent
            theoretical contributions in swarm intelligence and machine learning
            fields. And it also collects unpublished methods for practical
            problems in management science and industrial applications.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>
                Theoretical contributions in swarm intelligence algorithms:
                particle swarm optimization, bacterial foraging optimization,
                genetic algorithm, hydrogical cycle optimization, grey wolf
                optimization, artificial fish search algorithm, etc;
              </li>
              <li>
                Unpublished ideas in machine learning algorithms: reinforcement
                learning, deep learning, machine learning, meta-learning, etc.;
              </li>
              <li>
                Original work towards multi-objective problems, multi-task
                problems and constrained problems;
              </li>
              <li>
                 Efficient methods for practical problems in management science
                and industrial applications: intelligent transportation, medical
                dispatching, data mining, information systems, robotics,
                recommender systems, image processing, manufacturing system
                scheduling, etc.;
              </li>
              <li>
                Other Intelligent Computing and Swarm Intelligence Related
                Algorithms and Applications.
              </li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2022 instruction for authors and submit your
            paper via the ICSI 2022 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS1&quot; -- the Special Session on Swarm Intelligence and
              Machine Learning in Management Science and Industrial Applications
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Prof. Ben Niu</td>
                <td>Shenzhen University</td>
                <td>drniuben@gmail.com</td>
              </tr>
              <tr>
                <td>Dr. Tianwei Zhou</td>
                <td>Shenzhen University</td>
                <td>tianwei@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Shuang Geng</td>
                <td>Shenzhen University</td>
                <td>gs@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Hong Wang</td>
                <td>Shenzhen University</td>
                <td>ms_hongwang@163.com</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>

          <p align="center">&nbsp;</p>
          <br></br>

          <h2 id="session2">
            Special Session 2: &quot;Brain Storm Optimization Algorithm and Its Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <p>
            The Brain Storm Optimization (BSO) algorithm is a new kind of swarm
            intelligence algorithm, which is based on the collective behavior of
            human beings, that is, the brainstorming process. There are two
            major operations involved in BSO, i.e., convergent operation and
            divergent operation. A &quto;good enough &quto; solution could be
            obtained through recursive solution divergence and convergence in
            the search space. The designed optimization algorithm will naturally
            have the capability of both convergence and divergence.
            <br />
            <br />
            BSO algorithm possesses two kinds of functionalities: capability
            learning and capacity developing. The divergent operation
            corresponds to the capability of learning while the convergent
            operation corresponds to capacity developing. The capacity
            developing focuses on moving the algorithm&apos;s search to the
            area(s) where higher potential solutions may exist while the
            capability learning focuses on its actual search towards new
            solutions from the current solution for single-point based
            optimization algorithms or the current population of solutions for
            population-based swarm intelligence algorithms. The capability
            learning and capacity developing recycle to move individuals towards
            better and better solutions. The BSO algorithm, therefore, can also
            be called as a developmental brain storm optimization algorithm.
            <br />
            <br />
            The capacity developing is a top-level learning or macro-level
            learning methodology. The capacity developing describes the learning
            ability of an algorithm to adaptively change its parameters,
            structures, and/or its learning potential according to the search
            states of the problem to be solved. In other words, capacity
            developing is the search potential possessed by an algorithm.
            Capability learning is bottom-level learning or micro-level
            learning. The capability learning describes the ability of an
            algorithm to find better solutions from current solutions with the
            learning capacity it possesses.
            <br />
            <br />
            The BSO algorithm can also be seen as a combination of swarm
            intelligence and data mining techniques. Every individual in the
            brain storm optimization algorithm is not only a solution to the
            problem to be optimized, but also a data point to reveal the
            landscapes of the problem. The swarm intelligence and data mining
            techniques can be combined to produce benefits above and beyond what
            either method could achieve alone.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            This special session aims at presenting the latest developments of
            the BSO algorithm, as well as exchanging new ideas and discussing
            the future directions of developmental swarm intelligence. Original
            contributions that provide novel theories, frameworks, and
            applications to algorithms are very welcome for this Special
            session.
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2022 instruction for authors and submit your
            paper via the ICSI 2022 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS2&quot; -- the Special Session on Brain Storm Optimization
              Algorithms
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Prof. Gai-Ge Wang</td>
                <td>Ocean University of China</td>
                <td>gaigewang@163.com</td>
              </tr>
              <tr>
                <td>Prof. Lianbo Ma</td>
                <td>Northeastern University</td>
                <td>malb@swc.neu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Shi Cheng</td>
                <td>Shaanxi Normal University</td>
                <td>cheng@snnu.edu.cn </td>
              </tr>
              <tr>
                <td>Prof. Yuhui Shi</td>
                <td>Southern University of Science and Technology</td>
                <td>shiyh@sustech.edu.cn</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>
          <p align="center">&nbsp;</p>



          <div className="call-sp">


          <h2>ICSI 2022 Call for Special Session Proposals</h2>
          <br></br>
          <p align="justify">
            ICSI 2022 technical program will include special sessions. Their aim
            is to provide a complementary flavor to the regular sessions and
            should include hot topics of interest to the swarm intelligence
            community that may also go beyond disciplines traditionally
            represented at ICSI.
          </p>
          <p align="justify">
            Prospective organizers of special sessions should submit proposals
            indicating:
          </p>
          <p align="left">
            * Title of the session.
            <br />
            * Rationale of the need for the special session at ICSI.
            <br />
            <em>
              The rationale should stress the novelty of the topic and/or its
              multidisciplinary flavor, and must explain how it is different
              from the subjects covered by the regular sessions.
            </em>
            <br />
            * Short biography of the organizers.
            <br />* List of 5 – 6 contributed papers (including titles, authors,
            contact information of the corresponding author){" "}
            <em>
              (this can also be provided later when they become available).
            </em>
          </p>
          <p align="justify">
            Proposals are due on or before January 15, 2022 and should be sent
            via e-mail (in either pdf or plain ASCII text form) to the special
            sessions chair (to be announced) and forward to ICSI 2022
            secretariat at 
            <a href="mailto:icsi2022@iasei.org">icsi2022@iasei.org</a>.
          </p>
          <p align="justify">
            Proposals will be evaluated based on the timeliness of the topic,
            the qualifications of the organizers and the authors of the papers
            proposed in the session. In its decision, the committee will try to
            realize a balance of the topics across the technical areas
            represented in swarm intelligence.
          </p>
          <p align="justify">
            Notification of acceptance will be sent to the organizers no later
            than January 15, 2022. Authors of papers included in approved
            special sessions should submit their manuscript on or before January
            30, 2022. Manuscripts should conform to the formatting and
            electronic submission guidelines of regular ICSI papers (Springer’s
            LNCS format).
          </p>
          <p>
            When they submit papers, there is a choice to indicate that their
            papers are special session papers which will also undergo peer
            review. It is the responsibility of the organizers to ensure that
            their special session meets the ICSI quality standards. If, at the
            end of the review process, less than four papers are accepted, the
            session will be canceled and the accepted papers will be moved to
            regular sessions.
          </p>
          </div>
          {/* <h2 id="session2">
            Special Session 2: &quot; Competition on Single Objective Bounded Optimization Problems &quot;{" "}
          </h2>
          <p>
          Since optimization problems are widely used in real-world applications, it has always been one of the hot topics in research. With the popularity of machine learning and deep learning, how to efficiently and accurately solve optimization problems has become an urgent problem that needs to be addressed. Among them, the single-objective bounded optimization problem is one of the basic types of all optimization problems. Due to the complexity of modern optimization problems, the optimization of some complex functions is relatively difficult. Decades ago, the emergence of stochastic search algorithms such as evolutionary algorithms and swarm intelligence algorithms makes it possible to find the global optimal solutions of some complex functions. In order to test the performance of numerous evolutionary algorithms and swarm intelligence algorithms, we propose a test suite to complete this task.<br/><br/>
          This special session is devoted to the evolutionary algorithms and swarm intelligence algorithms for solving single-objective bounded optimization. We encourage all researchers to test their algorithms on the ICSI&apos;2022 test suite. This test suite includes 10 black-box test functions which means you do not need to know the exact form of these test functions. This form of benchmark functions is convenient for researchers to design and improve their algorithms, and it is also helpful for improving the generalization of the algorithms.<br/><br/>
          The participants are required to send the final results in the format specified in the technical report to the organizers. The original code of the algorithm also needs to be attached. The organizers will present an overall analysis and comparison based on these results. We will select the algorithms that perform well and give them a certain amount of bonuses. We are encouraging all researchers to test their algorithms on this test suite and take part in our competition.<br/><br/>
          We provide python and MATLAB code for our benchmark functions. All the code is available on <a href="https://github.com/cil-lab/icsi2022">Github</a>. You could check the README file to learn how to use our ICSI&apos;2022 test suite. Read this <a href="https://github.com/cil-lab/icsi2022/blob/main/ICSI_2022_Benchmark_functions.pdf">PDF</a> to understand what information should be submitted in the paper.

          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
		  <ul>
		  
            <li>Swarm intelligence algorithms: Particle swarm optimization, bacterial foraging optimization, grey wolf optimization, artificial fish search algorithm, Bees algorithms, etc;</li>
            <li>Evolutionary algorithms: Genetic Algorithm, differential evolution, evolutionary strategies, etc.;</li>
            <li>Other related heuristic algorithms.</li>
			</ul>

          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2022 instruction for authors and submit your paper via the ICSI 2022 online submission system. Please specify that your paper is for &nbsp;
            <strong>
              &quot;SS2&quot; -- Competition on Single Objective Bounded Optimization Problems
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Prof. Ying Tan</td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Tianwei Zhou</td>
                <td>Shenzhen University</td>
                <td>tianwei@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Shuang Geng</td>
                <td>Shenzhen University</td>
                <td>gs@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Hong Wang</td>
                <td>Shenzhen University</td>
                <td>ms_hongwang@163.com</td>
              </tr>
            </table>
          </p> */}

          {/* <h2 id="ss2">
            Special Session 2: &quot;Swarm Intelligence for Large-scale Discrete
            Optimization Problems&quot;
          </h2>
          <p>
            The discrete optimization problem can be seen everywhere in our
            daily life and attract the attention of a large number of
            practitioners throughout the year. Swarm intelligence (SI) as an
            effective method has been successfully applied to such problems and
            achieved many achievements thanks to its many excellent
            characteristics, such as simplicity, robustness, parallelism, and
            applicability. However, classical SI algorithms are also facing new
            challenges with the rapid increase in the scale of optimization
            problems, which requires more efficient search mechanism. The
            objective of this special session is to gather relevant researchers
            from all over the world and provide a platform for everyone to share
            your experience and exchange the latest ideas.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas relevant to the special issue include, but are not
            limited to, the following topics:
            <li>
              This special session receives all original and unpublished work
              that relates to large-scale discrete optimization problems and SI
              algorithms in both theoretical analysis and engineering
              applications.{" "}
            </li>
            <li>
              Theoretical analysis of the effectiveness of SI algorithms for
              discrete problems.
            </li>
            <li>
              New SI algorithms or search strategies for large-scale discrete
              optimization problems.
            </li>
            <li>
              The mixing of various optimization problems, such as large-scale
              multi-objective problem and large-scale constrained discrete
              problem.
            </li>
            <li>
              New discrete benchmark functions or models derived from real-world
              problems.
            </li>
            <li>
              Applications of SI algorithms to large-scale optimization
              problems, such as scheduling problem, delivery problem, and mixed
              discrete-continuous problem
            </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS2&quot; -- the Special Session on Swarm Intelligence for
              Large-scale Discrete Optimization Problems
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="https://www.eng.niigata-u.ac.jp/~yujun/">
                    Dr. Jun YU
                  </a>
                </td>
                <td>Niigata University</td>
                <td>yujun@ie.niigata-u.ac.jp</td>
              </tr>
              <tr>
                <td>
                  <a href="https://www.u-aizu.ac.jp/~peiyan/">Dr. Yan PEI</a>
                </td>
                <td>University of Aizu</td>
                <td>peiyan@u-aizu.ac.jp</td>
              </tr>
              <tr>
                <td>
                  <a href="http://evocomp.cse.kyutech.ac.jp/">
                    Dr. Kei OHNISHI
                  </a>
                </td>
                <td>Kyushu Institute of Technology</td>
                <td>ohnishi@cse.kyutech.ac.jp</td>
              </tr>
            </table>
          </p>

          <h2 id="ss3">
            Special Session 3: &quot;Firework Algorithms of Large-scale
            Population and Its High Dimensional Optimization Methods&quot;
          </h2>
          <p>
            In the past few years, the research of fireworks algorithms has
            developed a wealth of technologies and applications. However, with
            the development of science and technology, the environment for
            optimization tasks has changed dramatically. On the one hand, the
            objective functions are getting larger and larger in dimension and
            complexity. On the other hand, the parallel capabilities of current
            computing devices are generally far beyond what they were. Both
            aspects show great potential of fireworks algorithms with large
            population.
          </p>
          <p>
            The objective of this special session is to gather illuminating
            works on fireworks algorithms which focus on controlling and scaling
            the fireworks population. And it also collects instructive
            applications of fireworks algorithms on high dimensional
            optimization problems.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas relevant to the special issue include, but are not
            limited to, the following topics:
            <li>
              All effective fireworks algorithms with larger fireworks
              populations (at least more than 10 fireworks).{" "}
            </li>
            <li>
              Theoretical analysis of effectiveness and scalability of fireworks
              algorithms.{" "}
            </li>
            <li>
              New collaboration mechanism for multiple populations (or
              fireworks) in optimization.{" "}
            </li>
            <li>
              New benchmarking methods of high dimensional optimization
              problems.{" "}
            </li>
            <li>
              New technologies or algorithms (based on fireworks algorithm) for
              high dimensional optimization problems.{" "}
            </li>
            <li>
              Successful application of fireworks algorithms on high dimensional
              optimization problems.{" "}
            </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS3&quot; -- the Special Session on Firework Algorithms of
              Large-scale Population and Its High Dimensional Optimization
              Methods
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="https://www.cil.pku.edu.cn">Ying Tan</a>
                </td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Yifeng Li</td>
                <td>Peking University</td>
                <td>liyifeng0039@gmail.com</td>
              </tr>
              <tr>
                <td>Maiyue Chen</td>
                <td>Peking University</td>
                <td>mychen@pku.edu.cn</td>
              </tr>
            </table>
          </p>
          <h2 id="ss4">
            Special Session 4: &quot;Brain Storm Optimization Algorithms&quot;
          </h2>
          <p>
            The Brain Storm Optimization (BSO) algorithm is a new kind of swarm
            intelligence algorithm, which is based on the collective behavior of
            human beings, that is, the brainstorming process. There are two
            major operations involved in BSO, i.e., convergent operation and
            divergent operation. A &quot;good enough&quot; solution could be
            obtained through recursive solution divergence and convergence in
            the search space. The designed optimization algorithm will naturally
            have the capability of both convergence and divergence.
          </p>
          <p>
            BSO algorithm possesses two kinds of functionalities: capability
            learning and capacity developing. The divergent operation
            corresponds to the capability of learning while the convergent
            operation corresponds to capacity developing. The capacity
            developing focuses on moving the algorithm&apos;s search to the
            area(s) where higher potential solutions may exist while the
            capability learning focuses on its actual search towards new
            solutions from the current solution for single-point based
            optimization algorithms or the current population of solutions for
            population-based swarm intelligence algorithms. The capability
            learning and capacity developing recycle to move individuals towards
            better and better solutions. The BSO algorithm, therefore, can also
            be called as a developmental brain storm optimization algorithm.
          </p>
          <p>
            The capacity developing is a top-level learning or macro-level
            learning methodology. The capacity developing describes the learning
            ability of an algorithm to adaptively change its parameters,
            structures, and/or its learning potential according to the search
            states of the problem to be solved. In other words, capacity
            developing is the search potential possessed by an algorithm.
            Capability learning is bottom-level learning or micro-level
            learning. The capability learning describes the ability of an
            algorithm to find better solutions from current solutions with the
            learning capacity it possesses.
          </p>
          <p>
            The BSO algorithm can also be seen as a combination of swarm
            intelligence and data mining techniques. Every individual in the
            brain storm optimization algorithm is not only a solution to the
            problem to be optimized, but also a data point to reveal the
            landscapes of the problem. The swarm intelligence and data mining
            techniques can be combined to produce benefits above and beyond what
            either method could achieve alone.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            This special session aims at presenting the latest developments of
            the BSO algorithm, as well as exchanging new ideas and discussing
            the future directions of developmental swarm intelligence. Original
            contributions that provide novel theories, frameworks, and
            applications to algorithms are very welcome for this Special
            session. Potential topics include, but are not limited to:
            <li>Theoretical aspects of BSO algorithms; </li>
            <li>Analysis and control of BSO parameters;</li>
            <li>
              Parallelized and distributed realizations of BSO algorithms;
            </li>
            <li>BSO for multiple/many-objective optimization;</li>
            <li>BSO for constrained optimization;</li>
            <li>BSO for discrete optimization;</li>
            <li>BSO for large-scale optimization;</li>
            <li>BSO algorithm with data mining techniques;</li>
            <li>BSO in uncertain environments;</li>
            <li>BSO for real-world applications.</li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS4&quot; -- the Special Session on Brain Storm Optimization
              Algorithms
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>Lianbo Ma</td>
                <td>Northeastern University</td>
                <td>malb@swc.neu.edu.cn</td>
              </tr>
              <tr>
                <td>Xiujuan Lei</td>
                <td>Shaanxi Normal University</td>
                <td>xjlei@snnu.edu.cn</td>
              </tr>
              <tr>
                <td>Shi Cheng</td>
                <td>Shaanxi Normal University</td>
                <td>cheng@snnu.edu.cn</td>
              </tr>
            </table>
          </p>
          <h2 id="ss5">
            Special Session 5: &quot;Intelligent Algorithms for Swarm Robotics
            and Multibody System&quot;
          </h2>
          <p>
            Swarm robotics and multibody system are important topics in the
            robotic systems. Many intelligent algorithms, such as particle swarm
            optimization (PSO), ant colony optimization (ACO) and genetic
            algorithm (GA), have been used in robotics field. In recent decades,
            researchers noticed the truth of that ‘Intelligent Algorithms’ will
            be the soul of many systems and even services. From the technical
            point of view, intelligent algorithms have gradually appearing in,
            e.g., computation, modeling, diagnosis, scheduling management,
            optimization of system integration. Although systems employed with
            algorithms for robotics have improved performances, it is still a
            challenge to understand them fully and enhance their intelligence.
            There are many issues yet worth to be studied for intelligent
            algorithms in the fields of swarm robotics and multibody system. All
            of these evoke our research interests.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            The special session aims to collect a series of intelligent
            algorithms on ideas, concepts, and technologies that are used in
            swarm robotics and multibody system. Original researches are very
            welcomed for this session. Potential topics include, but are not
            limited to:
            <li>
              Purely intelligent algorithms research on PSO, ACO, NN, FA, BSO,
              GA, ABC, AIS, and so on with applications in potential
            </li>
            <li>Intelligent algorithms on mobile robotics</li>
            <li>Intelligent algorithms on multi-mobile manipulators</li>
            <li>Intelligent algorithms on underwater vehicles</li>
            <li>Intelligent algorithms for multibody system</li>
            <li>
              Intelligent algorithms for multi-robot environmental perception
            </li>
            <li>Intelligent algorithms for shape recognition </li>
            <li>Intelligent algorithms for multibody dynamics </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS5&quot;-- Intelligent Algorithms for Swarm Robotics and
              Multibody System
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="http://robotics-tongji.org/members/qtang">
                    Qirong Tang
                  </a>
                </td>
                <td>Tongji University</td>
                <td>qirong.tang@tongji.edu.cn</td>
              </tr>
              <tr>
                <td>Hai Huang</td>
                <td>Harbin Engineering University</td>
                <td>Huanghai@hrbeu.edu.cn</td>
              </tr>
            </table>
          </p>
          <h2 id="ss6">
            Special Session 6: &quot;Performance Assessment of Swarm
            Intelligence Algorithms&quot;
          </h2>
          <p>
            Solving hard optimization problems is one of the most important
            research topics due to the countless applications in different
            areas. Since solving such problems is of great importance, numerous
            metaheuristics were developed, many of which belong to the group of
            swarm intelligence (SI) optimization algorithms. In recent decades,
            there has been an explosion in the number of the proposed swarm
            intelligence algorithms most commonly compared to other
            metaheuristics using one statistic such as average or median of a
            selected performance measure which can lead to putting algorithms in
            different rankings even though there are only small differences
            between them. However, providing more insight about SI algorithms
            performances is still an open issue.
          </p>
          <p>
            The focus of this special session is to highlight theoretical and
            empirical research that investigates approaches needed to analyze SI
            algorithms and performance assessment with regard to different
            criteria. The session seeks to bring together researchers from
            around the globe for stimulating a discussion on recent advances in
            SI for providing explanations about algorithms’ performance. We
            invite in particular studies that include benchmarking analyses for
            SI algorithms.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            <li>
              Data-driven approaches (i.e. machine learning, information theory,
              statistics) for assessing algorithm performance
            </li>
            <li>Comparative studies between state-of-the-art SI algorithms</li>
            <li>Meta-learning</li>
            <li>Operators influence on SI algorithm behavior</li>
            <li>Parameters influence on SI algorithm behavior</li>
            <li>SI algorithm performance prediction</li>
            <li>Taxonomies of SI algorithms</li>
            <li>
              Machine learning for automatic SI algorithm selection and
              configuration
            </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS6&quot;-- Performance Assessment of Swarm Intelligence
              Algorithms
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="https://singidunum.ac.rs/profile/etuba">
                    Dr. Eva Tuba
                  </a>
                </td>
                <td>Singidunum University</td>
                <td>etuba@ieee.org</td>
              </tr>
              <tr>
                <td>
                  <a href="http://cs.ijs.si/popovski/">Gorjan Popovski</a>
                </td>
                <td>Jozef Stefan Institute</td>
                <td>gorjan.popovski@ijs.si</td>
              </tr>
              <tr>
                <td>
                  <a href="http://cs.ijs.si/eftimov/">Dr. Tome Eftimov</a>
                </td>
                <td>Jozef Stefan Institute</td>
                <td>tome.eftimov@ijs.si</td>
              </tr>
              <tr>
                <td>
                  <a href="https://singidunum.ac.rs/profile/mtuba">
                    Prof. dr Milan Tuba
                  </a>
                </td>
                <td>Singidunum University,</td>
                <td>tuba@ieee.org</td>
              </tr>
            </table>
          </p> */}
        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default SpecialSession;
